import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
import { isBuildingEmpty } from "./index187.js";
const pipeRemoveEmptyBuildings = ([parent]) => {
  const plots = getRgObjectsOfType(parent, RG_TYPE.Plot);
  for (const plot of plots) {
    plot.children = plot.children.filter((c) => c.type !== RG_TYPE.Building || c.type === RG_TYPE.Building && !isBuildingEmpty(c));
  }
  return [parent, void 0];
};
export {
  pipeRemoveEmptyBuildings
};
//# sourceMappingURL=index105.js.map
